import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Formik } from "formik";
import { motion, AnimatePresence } from "framer-motion";
import { contextapi } from "../../helpers/contextapi";
import { axiospost } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import { createapplicantrules } from "../../utils/validations";
import { Button } from "../../components/ui/Button";
import { FormInput } from "../../components/ui/FormInput";
import FormSelect from "../../components/ui/FormSelect";
import { cn } from "../../lib/utils";
import states_lga from "../../data/state_lga.json";

const countryCodes = [
  { label: "Nigeria (+234)", value: "234" },
  { label: "Afghanistan (+93)", value: "93" },
  { label: "Albania (+355)", value: "355" },
  { label: "Algeria (+213)", value: "213" },
  { label: "Angola (+244)", value: "244" },
  { label: "Argentina (+54)", value: "54" },
  { label: "Australia (+61)", value: "61" },
  { label: "Austria (+43)", value: "43" },
  { label: "Bahrain (+973)", value: "973" },
  { label: "Bangladesh (+880)", value: "880" },
  { label: "Belgium (+32)", value: "32" },
  { label: "Benin (+229)", value: "229" },
  { label: "Botswana (+267)", value: "267" },
  { label: "Brazil (+55)", value: "55" },
  { label: "Burkina Faso (+226)", value: "226" },
  { label: "Burundi (+257)", value: "257" },
  { label: "Cameroon (+237)", value: "237" },
  { label: "Canada (+1)", value: "1" },
  { label: "Cape Verde (+238)", value: "238" },
  { label: "Central African Republic (+236)", value: "236" },
  { label: "Chad (+235)", value: "235" },
  { label: "China (+86)", value: "86" },
  { label: "Colombia (+57)", value: "57" },
  { label: "Comoros (+269)", value: "269" },
  { label: "Congo (+242)", value: "242" },
  { label: "Congo DR (+243)", value: "243" },
  { label: "Cote d'Ivoire (+225)", value: "225" },
  { label: "Denmark (+45)", value: "45" },
  { label: "Djibouti (+253)", value: "253" },
  { label: "Egypt (+20)", value: "20" },
  { label: "Equatorial Guinea (+240)", value: "240" },
  { label: "Eritrea (+291)", value: "291" },
  { label: "Ethiopia (+251)", value: "251" },
  { label: "Finland (+358)", value: "358" },
  { label: "France (+33)", value: "33" },
  { label: "Gabon (+241)", value: "241" },
  { label: "Gambia (+220)", value: "220" },
  { label: "Germany (+49)", value: "49" },
  { label: "Ghana (+233)", value: "233" },
  { label: "Greece (+30)", value: "30" },
  { label: "Guinea (+224)", value: "224" },
  { label: "Guinea-Bissau (+245)", value: "245" },
  { label: "India (+91)", value: "91" },
  { label: "Indonesia (+62)", value: "62" },
  { label: "Iran (+98)", value: "98" },
  { label: "Iraq (+964)", value: "964" },
  { label: "Ireland (+353)", value: "353" },
  { label: "Israel (+972)", value: "972" },
  { label: "Italy (+39)", value: "39" },
  { label: "Jamaica (+1876)", value: "1876" },
  { label: "Japan (+81)", value: "81" },
  { label: "Jordan (+962)", value: "962" },
  { label: "Kenya (+254)", value: "254" },
  { label: "Kuwait (+965)", value: "965" },
  { label: "Lebanon (+961)", value: "961" },
  { label: "Lesotho (+266)", value: "266" },
  { label: "Liberia (+231)", value: "231" },
  { label: "Libya (+218)", value: "218" },
  { label: "Madagascar (+261)", value: "261" },
  { label: "Malawi (+265)", value: "265" },
  { label: "Malaysia (+60)", value: "60" },
  { label: "Mali (+223)", value: "223" },
  { label: "Mauritania (+222)", value: "222" },
  { label: "Mauritius (+230)", value: "230" },
  { label: "Mexico (+52)", value: "52" },
  { label: "Morocco (+212)", value: "212" },
  { label: "Mozambique (+258)", value: "258" },
  { label: "Namibia (+264)", value: "264" },
  { label: "Netherlands (+31)", value: "31" },
  { label: "New Zealand (+64)", value: "64" },
  { label: "Niger (+227)", value: "227" },
  { label: "Norway (+47)", value: "47" },
  { label: "Oman (+968)", value: "968" },
  { label: "Pakistan (+92)", value: "92" },
  { label: "Philippines (+63)", value: "63" },
  { label: "Poland (+48)", value: "48" },
  { label: "Portugal (+351)", value: "351" },
  { label: "Qatar (+974)", value: "974" },
  { label: "Rwanda (+250)", value: "250" },
  { label: "Saudi Arabia (+966)", value: "966" },
  { label: "Senegal (+221)", value: "221" },
  { label: "Sierra Leone (+232)", value: "232" },
  { label: "Singapore (+65)", value: "65" },
  { label: "Somalia (+252)", value: "252" },
  { label: "South Africa (+27)", value: "27" },
  { label: "South Korea (+82)", value: "82" },
  { label: "South Sudan (+211)", value: "211" },
  { label: "Spain (+34)", value: "34" },
  { label: "Sri Lanka (+94)", value: "94" },
  { label: "Sudan (+249)", value: "249" },
  { label: "Swaziland (+268)", value: "268" },
  { label: "Sweden (+46)", value: "46" },
  { label: "Switzerland (+41)", value: "41" },
  { label: "Tanzania (+255)", value: "255" },
  { label: "Thailand (+66)", value: "66" },
  { label: "Togo (+228)", value: "228" },
  { label: "Trinidad and Tobago (+1868)", value: "1868" },
  { label: "Tunisia (+216)", value: "216" },
  { label: "Turkey (+90)", value: "90" },
  { label: "Uganda (+256)", value: "256" },
  { label: "Ukraine (+380)", value: "380" },
  { label: "United Arab Emirates (+971)", value: "971" },
  { label: "United Kingdom (+44)", value: "44" },
  { label: "United States (+1)", value: "1" },
  { label: "Zambia (+260)", value: "260" },
  { label: "Zimbabwe (+263)", value: "263" },
];

const securityQuestions = [
  { label: "What is your mother's maiden name?", value: "What is your mother's maiden name?" },
  { label: "What was the name of your first school?", value: "What was the name of your first school?" },
  { label: "What is the name of your hometown?", value: "What is the name of your hometown?" },
  { label: "What is your favourite food?", value: "What is your favourite food?" },
  { label: "What is the name of your best friend?", value: "What is the name of your best friend?" },
  { label: "What was your childhood nickname?", value: "What was your childhood nickname?" },
];

const calculatePasswordStrength = (password) => {
  if (!password) return { strength: 0, label: '', color: '' };
  let strength = 0;
  if (password.length >= 8) strength++;
  if (password.length >= 12) strength++;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) strength++;
  if (/\d/.test(password)) strength++;
  if (/[^a-zA-Z\d]/.test(password)) strength++;
  if (strength <= 1) return { strength: 1, label: 'Weak', color: 'bg-red-500' };
  if (strength <= 3) return { strength: 2, label: 'Medium', color: 'bg-amber-500' };
  return { strength: 3, label: 'Strong', color: 'bg-green-500' };
};

const PasswordStrengthIndicator = ({ password }) => {
  const ps = React.useMemo(() => calculatePasswordStrength(password), [password]);
  if (!password) return null;
  return (
    <div className="mt-1.5">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs text-neutral-500">Strength:</span>
        <span className={`text-xs font-medium ${ps.strength === 1 ? 'text-red-600' : ps.strength === 2 ? 'text-amber-600' : 'text-green-600'}`}>{ps.label}</span>
      </div>
      <div className="h-1 bg-neutral-200 rounded-full overflow-hidden">
        <div className={`h-full rounded-full transition-all duration-300 ${ps.color}`} style={{ width: `${(ps.strength / 3) * 100}%` }} />
      </div>
    </div>
  );
};

const Register = () => {
  const context = React.useContext(contextapi);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = React.useState(0);
  const [lgaoriginlist, setlgaoriginlist] = React.useState("");
  const [duplicateErrors, setDuplicateErrors] = React.useState({});
  const [checkingField, setCheckingField] = React.useState({});

  const states = states_lga.map((v) => ({ label: v.state, value: v.state })).sort((a, b) => a.label.localeCompare(b.label));

  const tabs = [
    { label: 'Personal Info', fields: ['firstname', 'middlename', 'lastname', 'emailaddress', 'countrycode', 'phonenumber', 'homeaddress'] },
    { label: 'Account & Academic', fields: ['password', 'confirmpassword', 'jamb', 'stateoforigin', 'lgaoforigin'] },
    { label: 'Security', fields: ['security_question', 'security_answer'] },
  ];

  const checkDuplicate = async (field, value) => {
    if (!value || value.trim() === "") {
      setDuplicateErrors((prev) => ({ ...prev, [field]: null }));
      return;
    }
    setCheckingField((prev) => ({ ...prev, [field]: true }));
    try {
      const req = await axiospost("ms_applicant/check-duplicate", { field, value });
      if (req?.data?.exists) {
        setDuplicateErrors((prev) => ({
          ...prev,
          [field]: field === "emailaddress"
            ? "This email address is already registered"
            : "This phone number is already registered",
        }));
      } else {
        setDuplicateErrors((prev) => ({ ...prev, [field]: null }));
      }
    } catch {
      setDuplicateErrors((prev) => ({ ...prev, [field]: null }));
    } finally {
      setCheckingField((prev) => ({ ...prev, [field]: false }));
    }
  };

  React.useEffect(() => {
    localStorage.clear();
    context.setvalues({ ...context.values, main_menu: undefined });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _login = async (values) => {
    try {
      if (duplicateErrors.emailaddress || duplicateErrors.phonenumber) {
        swal("warning", "Please fix the duplicate email or phone number before submitting");
        return;
      }
      const fullPhone = `${values.countrycode}${values.phonenumber.replace(/^0+/, '')}`;
      const req = await axiospost("ms_applicant", {
        firstname: values.firstname,
        middlename: values.middlename,
        lastname: values.lastname,
        emailaddress: values.emailaddress,
        phonenumber: fullPhone,
        jamb: values.jamb,
        password: values.password,
        security_question: values.security_question,
        security_answer: values.security_answer,
        stateoforigin: values.stateoforigin,
        lgaoforigin: values.lgaoforigin,
        homeaddress: values.homeaddress,
      });
      if (req.status !== 200) throw new Error("Sorry, system could not finish processing your request");
      const { data } = req;
      if (data && data.type === "success") {
        swal(data.type, data.message);
        navigate("/");
      } else {
        throw new Error(data.message);
      }
    } catch ({ message }) {
      swal("warning", message);
    }
  };

  const handleStateChange = (stateValue) => {
    const stateObj = states_lga?.find((s) => s.state === stateValue);
    setlgaoriginlist(stateObj?.lgas || "");
  };

  const handleTabSwitch = async (tabIndex, errors, setTouched, values, validateForm) => {
    if (tabIndex > activeTab) {
      // Validate the entire form to get fresh errors
      const formErrors = await validateForm();
      // Check all tabs from current up to the target tab
      for (let t = activeTab; t < tabIndex; t++) {
        const tabFields = tabs[t]?.fields || [];
        const tabHasErrors = tabFields.some(f => formErrors[f]);
        if (tabHasErrors) {
          // Touch all fields in the blocking tab so errors show
          const touched = {};
          tabFields.forEach(f => touched[f] = true);
          setTouched((prev) => ({ ...prev, ...touched }));
          // Also block if there are duplicate errors
          if (duplicateErrors.emailaddress || duplicateErrors.phonenumber) {
            swal("warning", "Please fix the duplicate email or phone number before continuing");
          }
          setActiveTab(t);
          return;
        }
      }
      // Also block on duplicate errors for tab 0
      if (activeTab === 0 && (duplicateErrors.emailaddress || duplicateErrors.phonenumber)) {
        swal("warning", "Please fix the duplicate email or phone number before continuing");
        return;
      }
    }
    setActiveTab(tabIndex);
  };

  return (
    <div className="h-screen flex overflow-hidden">
      {/* Left Side - 40% - White with blue accent */}
      <div className="hidden lg:flex lg:w-[40%] relative bg-white overflow-hidden">
        <div className="relative z-10 flex flex-col items-center justify-center w-full px-10 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {/* Faint blue gradient glow behind logo */}
            <div className="relative mx-auto mb-5">
              <div className="absolute inset-0 -m-8 rounded-full bg-gradient-to-br from-primary-100 via-primary-50 to-transparent blur-2xl" />
              <img
                src="images/college-logo.png"
                alt="College Logo"
                className="h-28 mx-auto object-contain relative"
              />
            </div>
            <h1 className="text-2xl font-bold text-neutral-900 mb-1">
              Adamu Tafawa Balewa
            </h1>
            <h2 className="text-base font-medium text-neutral-600 mb-0.5">
              College of Education, Kangere
            </h2>
            <p className="text-sm text-neutral-400">
              Bauchi State
            </p>

            <div className="mt-8 space-y-3">
              {[
                'Quick Registration',
                'Secure & Private',
                'Easy Application',
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2.5 justify-center">
                  <div className="w-6 h-6 rounded-full bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <svg className="w-3.5 h-3.5 text-primary-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <span className="text-sm text-neutral-600">{item}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
        {/* Subtle separator line */}
        <div className="absolute right-0 top-[15%] bottom-[15%] w-px bg-neutral-200" />
      </div>

      {/* Right Side - 60% - Form only */}
      <div className="w-full lg:w-[60%] flex items-center justify-center px-6 sm:px-12 bg-neutral-50">
        <div className="w-full max-w-2xl">
          {/* Header */}
          <div className="mb-5 text-center">
            <h2 className="text-2xl font-bold text-neutral-900">
              Create Your Account
            </h2>
            <p className="text-sm text-neutral-500 mt-1">
              Admission Application Portal
            </p>
          </div>

          {/* Form Card */}
          <div className="bg-white rounded-2xl shadow-lg px-6 py-6 sm:px-8 sm:py-7">
            <Formik
              initialValues={{
                firstname: "",
                middlename: "",
                lastname: "",
                homeaddress: "",
                emailaddress: "",
                countrycode: "234",
                phonenumber: "",
                jamb: "",
                password: "",
                confirmpassword: "",
                stateoforigin: "",
                lgaoforigin: "",
                security_question: "",
                security_answer: "",
              }}
              validationSchema={createapplicantrules}
              onSubmit={_login}
            >
              {({ isSubmitting, values, errors, touched, setTouched, validateForm }) => {
                React.useEffect(() => {
                  if (values.stateoforigin) handleStateChange(values.stateoforigin);
                }, [values.stateoforigin]);

                return (
                <Form>
                  {/* Tab Navigation */}
                  <div className="flex mb-5 bg-neutral-100 rounded-lg p-1">
                    {tabs.map((tab, index) => (
                      <button
                        key={index}
                        type="button"
                        onClick={() => handleTabSwitch(index, errors, setTouched, values, validateForm)}
                        className={cn(
                          'flex-1 py-2 px-3 text-sm font-medium rounded-md transition-all duration-200',
                          activeTab === index
                            ? 'bg-white text-neutral-900 shadow-sm'
                            : 'text-neutral-500 hover:text-neutral-700'
                        )}
                      >
                        {tab.label}
                      </button>
                    ))}
                  </div>

                  <AnimatePresence mode="wait">
                    <motion.div
                      key={activeTab}
                      initial={{ opacity: 0, x: activeTab === 0 ? -10 : 10 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: activeTab === 0 ? 10 : -10 }}
                      transition={{ duration: 0.2 }}
                    >
                      {/* Tab 1: Personal Info */}
                      {activeTab === 0 && (
                        <div className="space-y-3.5">
                          <FormInput
                            name="firstname"
                            label="First Name"
                            placeholder="Enter first name"
                            leftIcon={
                              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                              </svg>
                            }
                          />
                          <div className="grid grid-cols-2 gap-3">
                            <FormInput name="middlename" label="Middle Name" placeholder="Middle name" />
                            <FormInput name="lastname" label="Last Name" placeholder="Last name" />
                          </div>

                          <div>
                            <FormInput
                              name="emailaddress"
                              label="Email Address"
                              type="email"
                              placeholder="Enter your email"
                              onBlur={(e) => checkDuplicate("emailaddress", e.target.value)}
                              leftIcon={
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                                </svg>
                              }
                            />
                            {checkingField.emailaddress && (
                              <p className="text-xs text-neutral-500 mt-0.5">Checking availability...</p>
                            )}
                            {duplicateErrors.emailaddress && !checkingField.emailaddress && (
                              <p className="text-xs text-danger-600 font-medium mt-0.5">{duplicateErrors.emailaddress}</p>
                            )}
                          </div>

                          <div>
                            <label className="block text-sm font-medium mb-1.5 text-neutral-700">
                              Phone Number
                            </label>
                            <div className="grid grid-cols-[200px_1fr] gap-2">
                              <FormSelect
                                name="countrycode"
                                placeholder="Code"
                                options={countryCodes}
                                clearable={false}
                                searchable={true}
                              />
                              <FormInput
                                name="phonenumber"
                                placeholder="8012345678"
                                onBlur={(e) => {
                                  const phone = e.target.value.replace(/^0+/, '');
                                  if (phone && values.countrycode) {
                                    checkDuplicate("phonenumber", `${values.countrycode}${phone}`);
                                  }
                                }}
                                leftIcon={
                                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                  </svg>
                                }
                              />
                            </div>
                            {checkingField.phonenumber && (
                              <p className="text-xs text-neutral-500 mt-0.5">Checking availability...</p>
                            )}
                            {duplicateErrors.phonenumber && !checkingField.phonenumber && (
                              <p className="text-xs text-danger-600 font-medium mt-0.5">{duplicateErrors.phonenumber}</p>
                            )}
                          </div>

                          <FormInput
                            name="homeaddress"
                            label="Contact Address"
                            placeholder="Enter your address"
                            leftIcon={
                              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                              </svg>
                            }
                          />

                          <div className="pt-1">
                            <Button
                              type="button"
                              variant="primary"
                              size="lg"
                              fullWidth
                              onClick={() => handleTabSwitch(1, errors, setTouched, values, validateForm)}
                              rightIcon={
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                              }
                            >
                              Continue
                            </Button>
                          </div>
                        </div>
                      )}

                      {/* Tab 2: Account & Academic */}
                      {activeTab === 1 && (
                        <div className="space-y-3.5">
                          <div className="grid grid-cols-2 gap-3">
                            <div>
                              <FormInput
                                name="password"
                                label="Password"
                                type="password"
                                placeholder="Create a password"
                                leftIcon={
                                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                  </svg>
                                }
                              />
                              <PasswordStrengthIndicator password={values.password} />
                            </div>
                            <FormInput
                              name="confirmpassword"
                              label="Confirm Password"
                              type="password"
                              placeholder="Confirm password"
                              leftIcon={
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                              }
                            />
                          </div>

                          <FormInput
                            name="jamb"
                            label="JAMB Registration Number"
                            placeholder="Enter your JAMB number"
                            leftIcon={
                              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                              </svg>
                            }
                          />

                          <div className="grid grid-cols-2 gap-3">
                            <FormSelect
                              name="stateoforigin"
                              label="State of Origin"
                              placeholder="Select state"
                              searchable
                              options={states}
                            />
                            <FormSelect
                              name="lgaoforigin"
                              label="LGA of Origin"
                              placeholder={lgaoriginlist ? "Select LGA" : "Select state first"}
                              searchable
                              disabled={!lgaoriginlist}
                              options={lgaoriginlist ? lgaoriginlist.map((r) => ({ label: r, value: r })) : []}
                            />
                          </div>

                          <div className="flex gap-3 pt-1">
                            <Button
                              type="button"
                              variant="outline"
                              size="lg"
                              onClick={() => setActiveTab(0)}
                              leftIcon={
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                </svg>
                              }
                            >
                              Back
                            </Button>
                            <Button
                              type="button"
                              variant="primary"
                              size="lg"
                              fullWidth
                              onClick={() => handleTabSwitch(2, errors, setTouched, values, validateForm)}
                              rightIcon={
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                              }
                            >
                              Continue
                            </Button>
                          </div>
                        </div>
                      )}

                      {/* Tab 3: Security */}
                      {activeTab === 2 && (
                        <div className="space-y-3.5">
                          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
                            <p className="text-xs text-amber-700 font-medium">
                              Your security question will be used to recover your account if you forget your password. Please choose a question and answer you will remember.
                            </p>
                          </div>

                          <FormSelect
                            name="security_question"
                            label="Security Question"
                            placeholder="Select a security question"
                            options={securityQuestions}
                            searchable={false}
                            required
                          />

                          <FormInput
                            name="security_answer"
                            label="Security Answer"
                            placeholder="Enter your answer"
                            required
                            leftIcon={
                              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                              </svg>
                            }
                          />

                          <div className="flex gap-3 pt-1">
                            <Button
                              type="button"
                              variant="outline"
                              size="lg"
                              onClick={() => setActiveTab(1)}
                              leftIcon={
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                </svg>
                              }
                            >
                              Back
                            </Button>
                            <Button
                              type="submit"
                              variant="primary"
                              size="lg"
                              fullWidth
                              loading={isSubmitting}
                            >
                              {isSubmitting ? "Creating Account..." : "Create Account"}
                            </Button>
                          </div>
                        </div>
                      )}
                    </motion.div>
                  </AnimatePresence>

                  <div className="flex items-center justify-center pt-4 mt-4 border-t border-neutral-100">
                    <span className="text-sm text-neutral-500 mr-1.5">Already have an account?</span>
                    <Link to="/" className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors">
                      Sign In
                    </Link>
                  </div>
                </Form>
                );
              }}
            </Formik>
          </div>

          <p className="text-center text-xs text-neutral-400 mt-3">
            By creating an account, you agree to our{" "}
            <a href="#" className="text-primary-600 hover:underline">Terms</a>
            {" "}and{" "}
            <a href="#" className="text-primary-600 hover:underline">Privacy Policy</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
